import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, ArrowRight, ShieldCheck, Terminal, Activity } from 'lucide-react';
import { Button, Card } from '../components/UI';
import { motion } from 'framer-motion';

const SignupSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const refId = (location.state as any)?.requestId
    ?? `REQ-${Math.floor(100000 + Math.random() * 900000)}`;

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-deep-0 relative overflow-hidden selection:bg-accent selection:text-white">
      {/* Background HUD Layers */}
      <div className="absolute inset-0 mesh-gradient opacity-10 -z-10" />
      <div className="radar-sweep opacity-20" />


      <div className="scale-75 origin-center w-full max-w-lg flex justify-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="w-full relative"
        >
          <Card className="p-12 text-center space-y-10 shadow-2xl bg-deep-1 border-accent/20 relative overflow-hidden group hover-scan">
            {/* Decorative scan line */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />

            {/* Success Orb */}
            <div className="relative w-24 h-24 bg-green-500/10 border border-green-500/20 rounded-full flex items-center justify-center mx-auto shadow-[0_0_50px_rgba(34,197,94,0.1)]">
              <CheckCircle className="w-12 h-12 text-green-500" />
              <motion.div
                animate={{ scale: [1, 1.2, 1], opacity: [0.2, 0.5, 0.2] }}
                transition={{ repeat: Infinity, duration: 3 }}
                className="absolute inset-0 rounded-full bg-green-500/20"
              />
            </div>

            <div className="space-y-3">
              <h1 className="text-4xl font-black text-white tracking-tighter italic uppercase">Request Received</h1>
              <p className="text-white/40 font-medium leading-relaxed">Your organization credentials have been queued for sovereign review.</p>
            </div>

            {/* Data Output Container */}
            <div className="bg-deep-0 border border-white/5 p-6 rounded-2xl space-y-5 relative">
              <div className="flex items-center justify-between text-[10px] font-black uppercase tracking-widest">
                <span className="text-white/20">Operational Status</span>
                <span className="text-amber-500 flex items-center gap-2">
                  <Activity className="w-3 h-3 animate-pulse" /> Pending Review
                </span>
              </div>

              <div className="h-px bg-white/5 w-full" />

              <div className="flex items-center justify-between text-[10px] font-black uppercase tracking-widest">
                <span className="text-white/20">Request Reference</span>
                <span className="font-mono text-white tracking-widest text-xs">{refId}</span>
              </div>
            </div>

            <div className="space-y-6">
              <Button
                className="w-full shadow-[0_0_20px_rgba(247,108,28,0.2)]"
                size="xl"
                onClick={() => navigate('/')}
              >
                Return to Website <ArrowRight className="ml-3 w-5 h-5" />
              </Button>
            </div>

            <p className="text-[10px] font-black uppercase tracking-[0.2em] text-white/10 hover:text-white/30 transition-colors cursor-help">
              Direct Support: info@vtuae.com
            </p>
          </Card>
        </motion.div>
      </div>
    </div>
  );
};

export default SignupSuccess;